/**
 * An export button's link. In a browser: exactly the `<a href download>` it
 * always was. In the Android app: the file goes to the phone's share sheet
 * instead (`platform/share.ts`), since the app has neither a cookie nor a
 * download manager.
 */

import * as React from "react";
import { toast } from "sonner";

import { exportsViaShareSheet, shareExport } from "@/platform/share";

export const ExportLink = React.forwardRef<
  HTMLAnchorElement,
  React.AnchorHTMLAttributes<HTMLAnchorElement> & { href: string; filename: string }
>(({ href, filename, onClick, ...props }, ref) => (
  <a
    ref={ref}
    href={href}
    download
    onClick={(e) => {
      onClick?.(e);
      if (!exportsViaShareSheet()) return;
      e.preventDefault();
      shareExport(href, filename).catch((err: Error) => toast.error(err.message));
    }}
    {...props}
  />
));
ExportLink.displayName = "ExportLink";
